 
<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" max-width="600px">
      <v-form ref="form" v-model="valid" lazy-validation id="newUrlForm">
        <v-card class="modern-modal">
          <div class="modal-head">
            <div class="modal-head-icon"><v-icon color="white">link</v-icon></div>
            <span class="modal-head-title">Alterar Links</span>
          </div>
          <v-card-text>
            <!-- <v-dialog v-model="dialog" width="500">
              <v-card>
                <div v-if="isLoad" class="text-xs-center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <div>
                    <b>Por favor aguarde...</b>
                  </div>
                </div>

                <v-flex v-show="showError">
                  <div class="red text-center">
                    <v-icon color="white">error</v-icon>
                    <span class="white--text"
                      ><p>
                        <strong>Erro ao Atualizar dados:</strong>
                      </p></span
                    >
                    <span class="white--text"
                      ><strong>
                        {{ errors["error"] }}
                      </strong></span
                    >
                  </div>
                  <v-btn
                    color="blue darken-1"
                    flat="flat"
                    @click.stop="dialog = false"
                    @click="disableError"
                  >
                    Fechar
                  </v-btn>
                </v-flex>
                <v-flex v-show="showSuccess">
                  <div class="green text-center">
                    <v-icon color="white">done</v-icon>
                    <span class="white--text"
                      ><p>
                        <strong>Dados alterados com sucesso.</strong>
                      </p></span
                    >
                  </div>
                  <v-btn
                    color="blue darken-1"
                    flat="flat"
                    @click.stop="dialog = false"
                    @click="disableNew"
                  >
                    Fechar
                  </v-btn>
                </v-flex>
              </v-card>
            </v-dialog> -->
            <!-- FORM -->
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="URL do Painel"
                    v-model="account.panel_url"
                    required
                    :rules="presenceRules"
                    type="text"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Webhook"
                    v-model="account.webhook"
                    required
                    :rules="protocolRules"
                    type="text"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="show = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" @click="updateAccount">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "NewUrl",

  created() {
    this.$store.dispatch("account/getAccount");

    EventBus.$on("show-change-form", () => {
      this.show = true;
    });
    EventBus.$on("hide-change-form", () => {
      this.show = false;
    });
  },
  data: () => ({
    show: false,
    valid: true,
    dialog: false,
    load: false,
    newAccount: {},
    account: {
      panel_url: "",
      webhook: "",
    },
    presenceRules: [(value) => !!value || "Campo Obrigatório"],
    protocolRules: [
      (v) => v.indexOf("https://") === 0 || "Formatação padrão: https://",
    ],
  }),

  computed: {
    ...mapGetters({
      activeNew: "account/activeNew",
      accountFromStore: "account/account",
      isLoad: "account/isLoad",
      errors: "account/errors",
      showError: "account/showError",
      showSuccess: "account/showSuccess",
    }),
  },
  watch: {
    account(newValues) {
      this.disableNew();
      this.newAccount = newValues;
    },
    show(newValue) {
      if (newValue == false) {
        this.account.panel_url = "";
      }
    },
    isLoad(newValue) {
      this.load = newValue;
    },
  },

  methods: {
    disableError() {
      this.$store.dispatch("account/showError", false);
    },
    disableNew() {
      this.$store.dispatch("account/activeNew", false);
      this.$store.dispatch("account/showError", false);
      this.$store.dispatch("account/showSuccess", false);
      this.$store.dispatch("account/isLoad", false);
    },
    updateAccount() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("account/isLoad", true);
        this.dialog = true;
        this.params = {
          account: {
            panel_url: this.account.panel_url,
            webhook: this.account.webhook,
          },
        };
        this.$store.dispatch("account/updateAccount", this.params);
        this.show = false;
      }
    },
  },
};
</script>
